export const arh_zh = {
    arh: {
        graph:"arh999囤币及逃顶指标",
        dayGraph:"最近24小时数据图",
        jzr:"江卓尔60日累计涨幅",
        ma370:"2年移动平均价格乘数",
        ndaq:"纳斯达克日K",
        btc:"BTC日K",
        pleaseTrade:"请选择交易对",
        contracts:"未平仓合约数",
        trading:"交易对",
        time:"时间",
        pleaseInterval:"请选择时间间隔",
        search:"搜索",
        distribution:"持有者地址数分布( 按余额分段)",
        ratio:"持有者地址数分布( 按余额分段)比率分布",
        ratio1:" 持有者币数量分布(按余额分段)",
        ratio2:" 持有者币数量分布(按余额分段)比率分布",
    },


};
export const arh_en = {
    arh: {
        graph:"arh999 hoarding and escape top index",
        dayGraph:"Data chart for the last 24 hours",
        jzr:"Jiang Zhuoer 60-day Cumulative Increase And Decrease",
        ma370:"2 year moving average price multiplier",
        ndaq:"Nasdaq Daily K",
        btc:"BTC Daily K",
        pleaseTrade:"Please select a trade pair",
        contracts:"Number of contracts open interest",
        trading:"Trading on",
        time:"time",
        pleaseInterval:"Please select an interval",
        search:"search",
        distribution:"Balance - number of holders distribution",
        ratio:"Balance to holder ratio distribution",
        ratio1:"Balance - the distribution of the number of coins held",
        ratio2:"The balance to holder ratio distribution",


},


};